export default __webpack_public_path__ + "static/media/card_2.ad76c0c6.svg";